/* resetMfa/sagas*/
import {
    select,
    all,
    fork,
    put,
    takeEvery,
    takeLatest,
  } from "redux-saga/effects";
  import { has, isNil, includes, isEmpty } from "ramda";
  import { ResetMfa, ResetMfaActionTypes } from "./types";
  import { save } from "../../repo/resetMfa";
  import {
    saveRequest,
    saveSuccess,
    saveError,
  } from "./actions";
  import { dirty } from "../session/actions";
  import { Error, isAuthError } from "../";
  
  function* handleSave(action: ReturnType<typeof saveRequest>) {
    try {
      const user = yield save(action.payload.data);
      // we may still have an error
      // if so then we should yield error
      if (user.errors && !isEmpty(user.errors)) {
        if (isAuthError(user.errors)) {
          yield put(dirty());
        }
        yield put(saveError(JSON.stringify(user.errors)));
        action.payload.callback &&
          action.payload.callback(JSON.stringify(user.errors), null);
      } else {
        yield put(saveSuccess(user));
        action.payload.callback && action.payload.callback(null, user);
      }
    } catch (err) {
      yield put(saveError(err));
      action.payload.callback &&
        action.payload.callback("An error occurred while saving User", null);
    }
  }
  
  function* watchSaveRequest() {
    yield takeEvery(ResetMfaActionTypes.SAVE_REQUEST, handleSave);
  }ResetMfaActionTypes
  
  export default function* resetMfaSaga() {
    yield all([
      fork(watchSaveRequest),
    ]);
  }
  